"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var TEXT_BOX_WIDTH_CALCULATION_OPTIONS = {
  PERCENT: 'PERCENT',
  MANUAL: 'MANUAL'
};
var _default = TEXT_BOX_WIDTH_CALCULATION_OPTIONS;
exports["default"] = _default;